"use client";

import { useEffect, useRef } from "react";
import { addEventSourceListener } from "./useEventSource";

/**
 * Subscribe to a single SSE event type to drive local UI state (progress /
 * status pushes that don't invalidate a cache). Mirrors the portal hook.
 */
export function useEventSourceEvent(
  eventType: string,
  handler: (payload: Record<string, unknown>) => void,
) {
  const handlerRef = useRef(handler);
  handlerRef.current = handler;

  useEffect(() => {
    const remove = addEventSourceListener(eventType, (payload) => {
      handlerRef.current(payload);
    });
    return remove;
  }, [eventType]);
}
